import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { IRootState } from '../../../../Storage/Redux/store';
import { IconSearch, IconXCircle } from '../../../Icon';
import { Link } from 'react-router-dom';
import TblRouteStore from '../../../../Interfaces/DataBase/TblRouteStore';

const SearchBar = (props: { service: string }) => {
  const [routes, setRoutes] = useState<TblRouteStore[]>([]);
  const [searchData, setSearchData] = useState<TblRouteStore[]>([]);
  const [searchText, setSearchText] = useState('');
  const [search, setSearch] = useState(false);

  const dbRoutes: TblRouteStore[] = useSelector(
    (state: IRootState) => state.routesStore
  );

  useEffect(() => {
    setRoutes(
      dbRoutes.filter(
        (obj) =>
          obj.service! === props.service && obj.menuShow! && !!obj.routePath
      )
    );
  }, [dbRoutes]);

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchText(value);
    const filteredData = value
      ? routes.filter((r: TblRouteStore) =>
          r.routeName?.toLowerCase().includes(value.toLowerCase())
        )
      : [];
    setSearchData(filteredData);
  };

  const clearSearch = () => {
    setSearchText('');
    setSearchData([]);
    setSearch(false);
  };

  const resultsDropdown = (
    <div className="absolute left-0 top-full w-full bg-white dark:bg-[#1b2e4b] mt-2 rounded-lg shadow-lg max-h-60 overflow-y-auto z-50">
      <div className="divide-y divide-gray-200 dark:divide-slate-600">
        {searchData.map((r, i) => (
          <Link
          to={r.routePath!}
              onClick={clearSearch}
            key={i}
            className="p-3 hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center px-2"
          >
            {r.routeIcon && (
              <div dangerouslySetInnerHTML={{ __html: r.routeIcon }}></div>
            )}

            <p
              className="flex items-center"
            >
              <span className="ltr:ml-3 rtl:mr-3 text-sm text-gray-900 dark:text-white">
                {r.routeName}
              </span>
            </p>
          </Link>
        ))}
      </div>
    </div>
  );

  const inputField = (
    <div className="relative w-full">
      <input
        type="text"
        value={searchText}
        className="form-input w-full ltr:pl-9 rtl:pr-9 ltr:pr-14 rtl:pl-14 peer bg-gray-100 dark:bg-[#0B1220] border border-transparent dark:border-[#263651] rounded-xl placeholder:tracking-wide placeholder:text-gray-400 dark:placeholder:text-[#5B6C88] focus:border-primary dark:focus:border-primary dark:text-white-light transition-colors"
        placeholder="Search Menu..."
        onChange={onChange}
      />
      <button
        type="button"
        className="absolute w-9 h-9 inset-0 ltr:right-auto rtl:left-auto appearance-none peer-focus:text-primary"
      >
        <IconSearch className="mx-auto" />
      </button>
      {searchText ? (
        <button
          type="button"
          className="absolute top-1/2 -translate-y-1/2 ltr:right-4 rtl:left-4 text-neutral-500 hover:text-danger"
          onClick={clearSearch}
        >
          <IconXCircle className="w-5 h-5" />
        </button>
      ) : (
        <span className="hidden xl:flex absolute top-1/2 -translate-y-1/2 ltr:right-2.5 rtl:left-2.5 items-center gap-0.5 rounded-md border border-gray-200 dark:border-[#263651] bg-white dark:bg-[#111C31] px-1.5 py-0.5 text-[10px] font-semibold text-gray-400 dark:text-[#5B6C88] pointer-events-none">
          ⌘K
        </span>
      )}
    </div>
  );

  return (
    <div className="relative w-full min-w-0">
      {/* Desktop only: always in normal document flow, never absolutely positioned */}
      <form
        className="hidden lg:block relative w-full"
        onSubmit={(e) => {
          e.preventDefault();
          setSearch(false);
        }}
      >
        {inputField}
        {searchData.length > 0 && resultsDropdown}
      </form>

      {/* Below xl (tablet/mobile): compact icon trigger */}
      {/* <button
        type="button"
        onClick={() => setSearch(!search)}
        className="search_btn xl:hidden p-2 rounded-full bg-white-light/40 dark:bg-dark/40 hover:bg-white-light/90 dark:hover:bg-dark/60"
      >
        <IconSearch className="w-4.5 h-4.5 mx-auto dark:text-[#d0d2d6]" />
      </button> */}

      {/* Below xl: expandable overlay field, only mounted while open */}
      {/* {search && (
        <form
          className="xl:hidden absolute inset-x-4 top-1/2 -translate-y-1/2 z-10"
          onSubmit={(e) => {
            e.preventDefault();
            setSearch(false);
          }}
        >
          {inputField}
          {searchData.length > 0 && resultsDropdown}
        </form>
      )} */}
    </div>
  );
};

export default SearchBar;
